import React from 'react';
import { FaShareAlt, FaTrashAlt } from 'react-icons/fa';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';

function ProductoCarrito({ producto, eliminarProducto, modificarCantidadProducto }) {
  const navigate = useNavigate();

  const handleRedirect = () => {
    navigate('/marcas');
  };

  const copiarAlPortapapeles = () => {
     
    const url = `${window.location.origin}/detalle/${producto.codigo}`;

    navigator.clipboard.writeText(url)
      .then(() => {
        Swal.fire('¡URL copiada!', 'La URL se ha copiado al portapapeles.', 'success');
      })
      .catch(() => {
        Swal.fire('Error', 'No se pudo copiar la URL. Intenta de nuevo.', 'error');
      });
  };

  // Determinar el precio y su etiqueta
  const precio = producto.mostrar_precio_dolar
    ? { valor: producto.precioventadolar, simbolo: 'US$ ' }
    : { valor: producto.precioventapeso || producto.preciopeso, simbolo: 'AR$ ' };

    return (
      <div className="w-full flex flex-col items-center">
        <h3 className="text-center text-base font-bold mb-2">
          {producto.nombre}
        </h3>
        <hr className="mb-2 w-11/12 mx-auto" />
        
        <div className="grid grid-cols-1 gap-4 w-full max-w-md">
          {/* Imagen debajo del nombre */}
          <div className="flex justify-center mb-3">
            <img
              src={producto.imagen}
              alt="Producto"
              className="w-full h-48 object-scale-down rounded"
            />
          </div>
          
          {/* Cantidad y Precio en la misma fila */}
          <div className="flex justify-between items-center w-full mb-3 px-4">
            {/* Cantidad */}
            <div className="flex flex-col items-center">
              <label
                htmlFor={`quantity-${producto.id}`}
                className="block text-lg font-bold mb-2 text-center"
              >
                Cantidad
              </label>
              <div className="flex items-center gap-2">
                <button
                  onClick={() => modificarCantidadProducto(producto.codigo, -1)}
                  className="bg-GrisClaro text-Negro px-3 py-1 rounded"
                >
                  -
                </button>
                <input
                  type="text"
                  id={`quantity-${producto.id}`}
                  value={producto.cantidad}
                  readOnly
                  className="border border-gray-300 text-center p-1 rounded w-12"
                />
                <button
                  onClick={() => modificarCantidadProducto(producto.codigo, 1)}
                  className="bg-GrisClaro text-Negro px-3 py-1 rounded"
                >
                  +
                </button>
              </div>
            </div>
    
            {/* Precio */}
            <div className="flex flex-col items-center">
              <label
                htmlFor={`total-${producto.id}`}
                className="block text-lg font-bold mb-3"
              >
                Precio
              </label>
              <p className="text-base font-semibold">
                {precio.simbolo}{precio.valor}
              </p>
            </div>
          </div>
    
          {/* Marca debajo del precio */}
          <div className="flex flex-col items-center mb-3">
            {producto.tipo === "producto" ? (
              <label className="text-sm text-GrisOscuro font-bold">
                MARCA:
                <button
                  onClick={() => handleRedirect()}
                  className="mx-1 text-sm font-bold text-Verde"
                >
                  {producto.nombreMarca}
                </button>
              </label>
            ) : (
              <label className="font-bold text-Verde">Servicio exclusivo para Clientes</label>
            )}
          </div>
    
          {/* Iconos de eliminar y compartir debajo de la marca */}
          <div className="flex justify-around gap-4 w-full px-4">
            <button
              onClick={() => eliminarProducto(producto.codigo)}
              className="text-Rojo text-xl sm:text-2xl"
            >
              <FaTrashAlt size={33} />
            </button>
            <button
              className="text-Amarillo text-xl sm:text-2xl"
              onClick={copiarAlPortapapeles}
            >
              <FaShareAlt size={33} />
            </button>
          </div>
        </div>
      </div>
    );
    
}

export default ProductoCarrito;
